import { useState } from "react";
import { Phone, MapPin, Mail, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg, waLink } from "@/lib/api";
import { useShop, useSeo } from "@/lib/store";

export default function Contact() {
  useSeo("Contact", "Contact DEN & THREADS, 128/1/4/3 Yashoda Nagar, Kanpur. Call or WhatsApp 9214356156.");
  const { settings: s } = useShop();
  const [f, setF] = useState({ name: "", email: "", phone: "", message: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await http.post("/contact", f); setSent(true); toast.success("Message sent"); } catch (err) { toast.error(errMsg(err)); }
  };
  const addr = s.address || "128/1/4/3, Yashoda Nagar, Kanpur, Uttar Pradesh, India";
  return (
    <div className="max-w-[1500px] mx-auto px-4 sm:px-8 py-14" data-testid="contact-page">
      <p className="eyebrow">Get in touch</p>
      <h1 className="font-display text-6xl sm:text-8xl leading-[0.86] mt-4">TALK TO<br /><span className="text-neon">THE DEN.</span></h1>
      <div className="grid lg:grid-cols-2 gap-12 mt-14">
        <div className="space-y-4">
          <p className="font-display text-3xl">DEN & THREADS</p>
          <p className="text-grey text-sm">D2C · B2C · B2B · Wholesale · Custom Printing</p>
          <p className="flex gap-3"><MapPin className="w-5 h-5 text-neon shrink-0" />{addr}</p>
          <p className="flex gap-3"><Mail className="w-5 h-5 text-neon" />{s.email}</p>
          <div className="flex flex-wrap gap-3 pt-2">
            <a href={`tel:+91${s.phone || "9214356156"}`} className="btn-ghost" data-testid="contact-call-button"><Phone className="w-4 h-4" />Call +91 {s.phone || "9214356156"}</a>
            <a href={waLink(s.whatsapp)} target="_blank" rel="noreferrer" className="btn-neon" data-testid="contact-whatsapp-button"><MessageCircle className="w-4 h-4" />WhatsApp chat</a>
          </div>
          <iframe title="DEN & THREADS location" data-testid="contact-map" loading="lazy" className="w-full aspect-video mt-6 grayscale invert-[.9] contrast-[.9] border border-white/10"
            src={`https://maps.google.com/maps?q=${encodeURIComponent("Yashoda Nagar, Kanpur, Uttar Pradesh")}&z=14&output=embed`} />
        </div>
        {sent ? <div className="border border-neon p-10 self-start" data-testid="contact-success"><p className="font-display text-4xl">MESSAGE RECEIVED.</p><p className="text-grey mt-2">We'll get back within one business day.</p></div> : (
          <form onSubmit={submit} className="space-y-4 self-start bg-[#171717] p-8" data-testid="contact-form">
            {[["name", "Name"], ["email", "Email", "email"], ["phone", "Phone (optional)"]].map(([k, l, t]) => (
              <label key={k} className="block"><span className="label">{l}</span><input required={k !== "phone"} type={t || "text"} className="field" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`contact-${k}-input`} /></label>
            ))}
            <label className="block"><span className="label">Message</span><textarea required rows={5} className="field" value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="contact-message-input" /></label>
            <button className="btn-neon w-full" data-testid="contact-submit-button">Send message</button>
          </form>
        )}
      </div>
    </div>
  );
}
